import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-84d6dbc8")

_pushScopeId("data-v-84d6dbc8")
const _hoisted_1 = { class: "p-tabview-nav-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "pi pi-chevron-left" }, null, -1)
const _hoisted_3 = {
  ref: "nav",
  class: "p-tabview-nav",
  role: "tablist"
}
const _hoisted_4 = {
  key: 0,
  class: "p-tabview-title"
}
const _hoisted_5 = {
  ref: "inkbar",
  class: "p-tabview-ink-bar"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "pi pi-chevron-right" }, null, -1)
const _hoisted_7 = { class: "p-tabview-panels" }
const _hoisted_8 = {
  key: 0,
  class: "p-tabview-panel",
  role: "tabpanel"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_ripple = _resolveDirective("ripple")

  return (_openBlock(), _createBlock("div", {
    class: ["p-tabview p-component", { 'p-tabview-scrollable': _ctx.scrollable }]
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.scrollable && !_ctx.backwardIsDisabled)
        ? _withDirectives((_openBlock(), _createBlock("button", {
            key: 0,
            ref: "prevBtn",
            class: "p-tabview-nav-prev p-tabview-nav-btn p-link",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navBackward && _ctx.navBackward(...args))),
            type: "button"
          }, [
            _hoisted_2
          ], 512)), [
            [_directive_ripple]
          ])
        : _createCommentVNode("", true),
      _createVNode("div", {
        ref: "content",
        class: "p-tabview-nav-content",
        onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
      }, [
        _createVNode("ul", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
            return (_openBlock(), _createBlock("li", {
              role: "presentation",
              key: _ctx.getKey(tab,i),
              class: [{'p-highlight': (_ctx.d_activeIndex === i), 'p-disabled': _ctx.isTabDisabled(tab)}]
            }, [
              _withDirectives(_createVNode("a", {
                role: "tab",
                class: "p-tabview-nav-link",
                onClick: ($event: any) => (_ctx.onTabClick($event, i)),
                onKeydown: ($event: any) => (_ctx.onTabKeydown($event, i)),
                tabindex: _ctx.isTabDisabled(tab) ? undefined : 0,
                "aria-selected": _ctx.d_activeIndex === i
              }, [
                (tab.props && tab.props.header)
                  ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(tab.props.header), 1))
                  : _createCommentVNode("", true),
                (tab.children && tab.children.header)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(tab.children.header), { key: 1 }))
                  : _createCommentVNode("", true)
              ], 40, ["onClick", "onKeydown", "tabindex", "aria-selected"]), [
                [_directive_ripple]
              ])
            ], 2))
          }), 128)),
          _createVNode("li", _hoisted_5, null, 512)
        ], 512)
      ], 544),
      (_ctx.scrollable && !_ctx.forwardIsDisabled)
        ? _withDirectives((_openBlock(), _createBlock("button", {
            key: 1,
            ref: "nextBtn",
            class: "p-tabview-nav-next p-tabview-nav-btn p-link",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navForward && _ctx.navForward(...args))),
            type: "button"
          }, [
            _hoisted_6
          ], 512)), [
            [_directive_ripple]
          ])
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_7, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
        return (_openBlock(), _createBlock(_Fragment, {
          key: _ctx.getKey(tab,i)
        }, [
          (_ctx.lazy ? (_ctx.d_activeIndex === i) : true)
            ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_8, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(tab)))
              ], 512)), [
                [_vShow, _ctx.lazy ? true: (_ctx.d_activeIndex === i)]
              ])
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ], 2))
})